import { BaseDataItem, ContainerLayouts, LayoutDataItems, SingleLayoutData } from '@wix/thunderbolt-becky-types'
import { CONTAINER_LAYOUTS_TYPES } from './containerLayoutTypes'
import type { BreakpointsVariantsToLayoutsMap } from '../features/responsiveLayout/responsiveLayout.types'

const ITEM_LAYOUTS = ['componentLayout', 'containerLayout', 'itemLayout'] as const

export const isSingleLayoutData = (item: BaseDataItem): item is SingleLayoutData => item.type === 'SingleLayoutData'

export const getResponsiveItemLayouts = (item: LayoutDataItems): Array<LayoutDataItems> => {
	if (!isSingleLayoutData(item)) {
		return [item]
	}

	const res = []
	const { spx } = item

	for (const layout of ITEM_LAYOUTS) {
		const layoutItem = item[layout]
		if (layoutItem?.type) {
			res.push({ ...layoutItem, spx })
		}
	}
	return res
}

export const isContainerLayout = (layout: LayoutDataItems): layout is ContainerLayouts =>
	CONTAINER_LAYOUTS_TYPES.has(layout.type)

export const getContainerLayouts = (breakpointToLayouts: BreakpointsVariantsToLayoutsMap) =>
	Object.values(breakpointToLayouts)
		.flatMap((x) => Object.values(x).flatMap((y) => y))
		.filter(isContainerLayout)
